import { jsx as o } from "react/jsx-runtime";
import { I as r } from "../icon-DNHpBTHs.mjs";
const c = {
  name: "checkmark",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.06 3.795a.9.9 0 0 1 .145 1.264l-11.5 14.5a.9.9 0 0 1-1.341.077l-6-6a.9.9 0 0 1 1.272-1.272l5.286 5.286L19.795 3.94a.9.9 0 0 1 1.264-.145Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark"],
  category: "utility"
}, a = (e) => /* @__PURE__ */ o(r, { ...e, svg: c });
a.displayName = "IconCheckmark";
export {
  a as IconCheckmark
};
//# sourceMappingURL=checkmark.es.js.map
